<template>
    <div id="ques-div-loading" class="vs-con-loading__container">
        <vue-headful :title="$t('add_questionnaire')" />
        <vx-card class="lg:p-5 main_bg_card">
            <div
                style="cursor: pointer"
                class="flex back-div mb-5"
                @click="goBack()"
            >
                <feather-icon class="cursor-pointer" icon="ArrowLeftIcon" />
                <span>{{ $t("return_back") }}</span>
            </div>
            <div class="mb-5 name mob_card">
                <span>{{ $t("employment_questionnaire") }}</span>
            </div>
            <div class="lg:flex mb-10 lg:mb-6">
                <div>
                    <img :src="user.avatar" style="object-fit: cover" alt="" width="105" height="105" />
                </div>
                <div class="lg:ml-4">
                    <div class="name mb-5 text-lg lg:text-xl">
                        {{ user.firstName + " " +  user.middleName + " " + user.lastName }}
                    </div>
                    <div class="mt-4">
                        <span class="bold mb-2">{{
                            $t("study_plan")
                        }}</span>
                        <multiselect
                            v-model="selectedPlan"
                            :options="studyPlans"
                            :searchable="false"
                            open-direction="top"
                            :close-on-select="true"
                            v-validate="'required'"
                            label="name"
                            :placeholder="$t('study_plan')"
                            :show-labels="false"
                            @input="StudyPlanSet()"
                        >
                        </multiselect>
                        <!-- <v-select class="w-full" label="text" :options="schedules" v-model="selectedSchedule" @input="setSchedule()"></v-select> -->
                    </div>

                </div>
            </div>
            <div class="mb-5 mob_card">
                <div class="mb-10">
                    <div class="mb-2 lg:mb-5">
                        <span class="subtitle-text">{{
                            $t("main_information")
                        }}</span>
                    </div>
                    <div class="mb-10">
                        <div class="vals_list">
                            <div class="item lg:flex items-center">
                                <div class="label font-semibold">{{ $t("phone") }}:</div>
                                <div>{{ user.phone }}</div>
                            </div>
                            <div class="item lg:flex items-center">
                                <div class="label font-semibold">{{ $t("email") }}:</div>
                                <div>{{ user.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-row vs-w="12" class="mb-5">
                    <vs-col vs-sm="12" vs-lg="4" class="lg:pr-5 mb-2 lg:mb-0">
                        <span>{{ $t("direction_of_employment") }}</span>
                        <multiselect
                            @open="open_direction_of_employment"
                            v-model="selectedDirectionOfEmployment"
                            :options="directions_of_employment"
                            :searchable="false"
                            open-direction="top"
                            :close-on-select="true"
                            label="name"
                            name="direction_of_employment"
                            v-validate="'required'"
                            :placeholder="`${ $t('choose_option') }${'*' }`"
                            :show-labels="false"
                            @input="setDirectionOfEmployment()"
                        >
                        </multiselect>

                        <span
                            class="text-danger w-full text-sm"
                            v-show="errors.has(`direction_of_employment`)||address_errors.indexOf('selectedDirectionOfEmployment') >= 0"
                        >{{ $t("validation_required") }}</span>
                    </vs-col>
                    <vs-col vs-sm="12" vs-lg="4" class="lg:pr-5 mb-2 lg:mb-0">
                        <span>{{ $t("vacancy") }}</span>
                        <multiselect
                            @open="open_get_vacancies"
                            v-model="selectedVacancy"
                            :options="vacancies"
                            :searchable="false"
                            open-direction="top"
                            :close-on-select="true"
                            label="name"
                            name="vacancy"
                            :placeholder="$t('choose_option')"
                            :show-labels="false"
                            @input="setVacancy()"
                        >
                        </multiselect>
<!--                        <span-->
<!--                            class="text-danger w-full text-sm"-->
<!--                            v-show="errors.has(`vacancy`)"-->
<!--                        >{{ $t("validation_required") }}</span-->
<!--                        >-->
                    </vs-col>
                    <vs-col vs-sm="12" vs-lg="4" >
                        <span>{{ $t("future_plans") }}</span>
                        <multiselect
                            @open="open_future_plans"
                            v-model="selectedFuturePlan"
                            :options="future_plans"
                            :searchable="false"
                            open-direction="top"
                            :close-on-select="true"
                            label="name"
                            name="future_plans"
                            :placeholder="$t('choose_option')"
                            :show-labels="false"
                            @input="setFuturePlan()"
                        >
                        </multiselect>
<!--                        <span-->
<!--                            class="text-danger w-full text-sm"-->
<!--                            v-show="errors.has(`future_plans`)"-->
<!--                        >{{ $t("validation_required") }}</span-->
<!--                        >-->
                    </vs-col>
                </vs-row>
            </div>
<!--            <div :class="classForDOM.grandParent">-->
<!--                <vs-card>-->
<!--                    <span class="text-xl font-semibold pr-2">{{-->
<!--                        $t("region_of_future_employment")-->
<!--                    }}</span>-->
<!--                    <AddressForm-->
<!--                        ref="registration_address"-->
<!--                        @setData="setAddress"-->
<!--                        name="registration"-->
<!--                        :address_errors="address_errors"-->
<!--                        :data="qestionnaire.address_of_registration"-->
<!--                        :profileUid="user.profileId"-->
<!--                        :type-uid="typesAddress['REG']"-->
<!--                    />-->
<!--                </vs-card>-->
<!--            </div>-->
            <div  class="mb-5 mob_card">
                <vx-card>
                    <vs-row>
                        <vs-col vs-lg="6" vs-sm="12" class="mb-5">
                            <span>
                                {{$t('moving_location')}}
                            </span>
                            <vs-input style="width: 100%;"  v-model="value1" />
                        </vs-col>
                        <vs-col vs-w="12" >
                            <div class="mb-5" style="width: fit-content;">
                                <vs-checkbox v-model="qestionnaire.work_in_speciality">
                                    <span>
                                        {{ $t("employed_by_spec") }}
                                    </span>
                                </vs-checkbox>
                            </div>
                            <div class="mb-5" style="width: fit-content;">
                                <vs-checkbox v-model="qestionnaire.work_6_month">
                                    <span>
                                        {{ $t("work_for_last_six_months") }}
                                    </span>
                                </vs-checkbox>
                            </div>
                            <div class="mb-5" style="width: fit-content;">
                                <vs-checkbox v-model="qestionnaire.work_in_home">
                                    <span>
                                        {{ $t("work_in_home") }}
                                    </span>
                                </vs-checkbox>
                            </div>
                            <div style="width: fit-content;">
                                <vs-checkbox v-model="qestionnaire.not_emplyed">
                                    <span>
                                        {{ $t("recognized_as_unemployed") }}
                                    </span>
                                </vs-checkbox>
                            </div>
                        </vs-col>
                        <vs-col vs-w="12" class="mt-5">
                            <vs-row>
                                <vs-col vs-lg="6" vs-xs="12">
                                    <span>
                                        {{$t('additional_information')}}
                                    </span>
                                    <vs-textarea v-model="additional_information" />
                                </vs-col>
                            </vs-row>
                        </vs-col>
                    </vs-row>
                </vx-card>
            </div>
            <div class="submit-buttons mob_card">
                <vs-button
                    v-if="qestionnaire.uid"
                    ref="loadableButton"
                    id="delete-btn"
                    class="mr-2 vs-con-loading__container"
                    color="danger"
                    @click="deleteQes()"
                >
                    {{ $t("remove") }}
                </vs-button>
                <vs-button
                    ref="loadableButton"
                    id="btn-save-loading"
                    class="vs-con-loading__container"
                    @click="createQUE()"
                >
                    {{ $t("save") }}</vs-button
                >
            </div>
        </vx-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddressForm from "@/pages/Home/Employment/components/AddressForm";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
export default {
    data() {
        return {
            selectedSchedule: null,
            file: true,
            cropper: null,
            dataUrl: null,
            croperModal: false,
            cropperOptions: {
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 1,
                movable: true,
                zoomable: true,
                minCropBoxWidth: 150,
                minCropBoxHeight: 150,
            },
            qestionnaire: {
                is_employed: "1",
                work_in_speciality: false,
                work_6_month: false,
                not_emplyed: false,
                work_in_home: false,
                vacancy: null,
                future_plans: null,
                direction_of_employment: null,
                address_of_registration: null,
                questionnaire_avatar: "",
                avatar: "",
                position: "",
                company_name: "",
                current_salary: null,
                schedule: "",
                plan: "",
                place: "",
                study_plan: "",
            },
            typesAddress: {
                "REG": ""
            },
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
            emplaymentStatus: [
                {
                    status: this.$t("not_employed"),
                    key: 2,
                },
                {
                    status: this.$t("employed"),
                    key: 1,
                },
            ],
            schedules: [],
            selectedPlan: null,
            selectedVacancy: null,
            selectedFuturePlan: null,
            selectedDirectionOfEmployment: null,
            empStatus: {
                status: this.$t("not_employed"),
                key: 2,
            },
            studyPlans: [],
            vacancies: [],
            directions_of_employment: [],
            future_plans: [],
            address_errors: [],
            additional_information:''
        };
    },
    watch: {
        croperModal() {
            this.hiddenHandler();
        },
    },
    computed: {
        ...mapGetters({
            user: "user/getUser",
        }),

    },
    components: {
        AddressForm,
    },
    methods: {
        ...mapActions({
            getStudyPlans: "employment/getStudyPlans",
            getFuturePlans: "employment/getFuturePlans",
            getDirectionsOfEmployment: "employment/getDirectionsOfEmployment",
            getVacancies: "employment/getVacancies",
            createQuestionnaire: "employment/createQuestionnaire",
            getQuestionnaireDetail: "employment/getQuestionnaireDetail",
            updateQuestionnaire: "employment/updateQuestionnaire",
            deleteQuestionnaire: "employment/deleteQuestionnaire",
            getSchedules: "employment/getSchedules",
        }),
        goMyQuestionnaires(){
            this.$router.push({
                name: "my_questionnaires",
            });
        },
        async getTypesAddress() {
            try {
                this.$vs.loading();

                const response = (await this.$http.get("user/address-types/"))
                    .data;

                let object = {};

                for (let i = 0; i < response.length; i++) {
                    let e = response[i];
                    object[e.code] = e.uid;
                }

                this.typesAddress = object;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        setAddress({ name, data }) {
            this.qestionnaire.address_of_registration = data;
        },
        async validateData(){
            let result;
            this.address_errors = [];
            if(!this.qestionnaire.address_of_registration || !this.qestionnaire.address_of_registration.country){
                this.address_errors.push("country")
            }
            if(!this.selectedDirectionOfEmployment){
                this.address_errors.push("selectedDirectionOfEmployment")
            }
            if ((!this.qestionnaire.address_of_registration.region&&this.qestionnaire.address_of_registration.country.code=='KZ')){
                this.address_errors.push("region")
            }
            await this.$validator.validateAll().then(async (res) => {
                if(this.address_errors.length == 0 && res) result = true;
                else result = false;
            });
            return result;
        },
        async createQUE() {
            try{
                let result = await this.validateData();
                // console.log(result);
                if(result){
                    this.$vs.loading({
                        container: "#btn-save-loading",
                        scale: 0.6,
                    });

                    if (this.qestionnaire.uid && this.qestionnaire.uid !== "") {

                        this.qestionnaire['additional_information'] = this.additional_information
                        let outData = this.qestionnaire;
                        let res = await this.updateQuestionnaire(outData);
                        if(res["error"]){
                            this.$vs.notify({
                                text: this.$t("questoinnaire_address_error"),
                                color: "danger",
                            });
                        }else{
                            this.$vs.notify({
                                text: this.$t("questionnaire_updated"),
                                color: "success",
                            });
                            this.goMyQuestionnaires();
                        }

                    } else {
                        //let outData = this.checkEmployed(this.qestionnaire);
                        this.qestionnaire['additional_information'] = this.additional_information
                        let res = await this.createQuestionnaire(this.qestionnaire);
                        if(res["error"]){
                            this.$vs.notify({
                                text: this.$t("questoinnaire_address_error"),
                                color: "danger",
                            });
                        }else{
                            this.$vs.notify({
                                text: this.$t("questionnaire_created"),
                                color: "success",
                            });
                            this.goMyQuestionnaires();
                        }

                    }
                    this.$vs.loading.close("#btn-save-loading > .con-vs-loading");
                }else{
                    this.$vs.notify({
                        title: this.$t("warning"),
                        text: this.$t("Fillallfields"),
                        color: "danger",
                    });
                }
            } catch (e) {
                this.$vs.notify({
                    title: this.$t("warning"),
                    text: this.$t("Fillallfields"),
                    color: "danger",
                });
            }
        },
        checkEmployed(data) {
            // console.log('checkEmployed',data)
            return data;
        },
        async deleteQes() {
            this.$vs.loading({
                container: "#delete-btn",
                scale: 0.6,
            });
            await this.deleteQuestionnaire(this.qestionnaire.uid);
            let obj = {
                is_employed: "",
                work_in_speciality: false,
                work_6_month: false,
                not_emplyed: false,
                position: "",
                company_name: "",
                current_salary: null,
                schedule: "",
                plan: "",
                place: "",
                study_plan: "",
                work_in_home: false,
                vacancy: null,
                future_plans: null,
                address_of_registration: null,
                direction_of_employment: null,
            };
            this.qestionnaire = obj;
            this.selectedPlan = null;
            this.selectedVacancy = null;
            this.selectedDirectionOfEmployment = null;
            this.selectedFuturePlan = null;
            this.empStatus = null;
            this.$vs.notify({
                text: this.$t("questoinnaire_removed"),
                color: "danger",
            });
            this.goMyQuestionnaires();
            this.$vs.loading.close("#delete-btn > .con-vs-loading");
        },
        StudyPlanSet() {
            this.qestionnaire.study_plan = this.selectedPlan.uid;
        },
        setSchedule() {
            this.qestionnaire.schedule = this.selectedSchedule.key;
        },
        empStatusSet() {
            this.qestionnaire.is_employed = this.empStatus.key.toString();
        },
        setVacancy() {
            this.qestionnaire.vacancy = this.selectedVacancy.uid;
        },
        setFuturePlan() {
            this.qestionnaire.future_plans = this.selectedFuturePlan.uid;
        },
        setDirectionOfEmployment() {
            this.qestionnaire.direction_of_employment = this.selectedDirectionOfEmployment.uid;
        },
        goBack() {
            this.$router.push({
                name: "my_questionnaires",
            });
        },
        async init() {
            this.$vs.loading();


            this.uploadSettings = (
                await this.$http.get(`/common/settings/`)
            ).data[0];


            let plans = [];
            await this.getStudyPlans().then(function(res){
                for(var i = 0; i < res.length; i++){
                    res[i].key = i.toString();
                    try{
                        res[i].name = res[i].speciality.name;
                    } catch{
                        res[i].name = "Уч.план " + res[i].number;
                    }

                }
                plans = res;

            }, function(err){});

            this.studyPlans = plans;

            if(this.studyPlans.length == 1){
                this.selectedPlan = this.studyPlans[0];
                this.qestionnaire.study_plan = this.studyPlans[0].uid;
            }

            if(this.$route.params.uid){
                let qestionnnaire = null;
                qestionnnaire = await this.getQuestionnaireDetail(this.$route.params.uid);
                let vacancy_uid = qestionnnaire.vacancy ? qestionnnaire.vacancy.uid : null
                let study_plan_uid = qestionnnaire.study_plan ? qestionnnaire.study_plan.uid : null
                let future_plan_uid = qestionnnaire.future_plans ? qestionnnaire.future_plans.uid : null
                let direction_employment_uid = qestionnnaire.direction_of_employment ? qestionnnaire.direction_of_employment.uid : null
                this.additional_information = qestionnnaire.additional_information
                if (qestionnnaire != null) {
                    let obj = {
                        uid: qestionnnaire.uid,
                        is_employed: qestionnnaire.is_employed,
                        work_in_speciality: qestionnnaire.work_in_speciality,
                        work_6_month: qestionnnaire.work_6_month,
                        not_emplyed: qestionnnaire.not_emplyed,
                        position: qestionnnaire.position,
                        company_name: qestionnnaire.company_name,
                        current_salary: qestionnnaire.current_salary,
                        schedule: qestionnnaire.schedule,
                        plan: qestionnnaire.plan,
                        place: qestionnnaire.place,
                        study_plan: study_plan_uid,
                        work_in_home: qestionnnaire.work_in_home,
                        vacancy: vacancy_uid,
                        future_plans: future_plan_uid,
                        address_of_registration: qestionnnaire.address_of_registration,
                        direction_of_employment: direction_employment_uid,
                    };
                    let sp = {
                        name: "Уч. план "+qestionnnaire.study_plan.number,
                        uid: qestionnnaire.study_plan.uid,
                    };
                    if(qestionnnaire.direction_of_employment){
                        let doe = {
                            name: qestionnnaire.direction_of_employment.name,
                            uid: qestionnnaire.direction_of_employment.uid,
                        };
                        this.selectedDirectionOfEmployment = doe;
                    }

                    if(qestionnnaire.vacancy){
                        let vacancy = {
                            name: qestionnnaire.vacancy.job.name,
                            uid: qestionnnaire.vacancy.uid,
                        };
                        this.selectedVacancy = vacancy;
                    }

                    if(qestionnnaire.future_plans){
                        let fp = {
                            name: qestionnnaire.future_plans.name,
                            uid: qestionnnaire.future_plans.uid,
                        };
                        this.selectedFuturePlan = fp;
                    }


                    this.selectedPlan = sp;
                    this.selectedSchedule = this.schedules[parseInt(qestionnnaire.schedule)];
                    if (qestionnnaire.is_employed === "1") {
                        this.empStatus = this.emplaymentStatus[1];
                    } else {
                        this.empStatus = this.emplaymentStatus[0];
                    }

                    this.qestionnaire = obj;
                } else{
                    this.$router.push({
                        name: "my_questionnaires",
                    });
                }
            }

            this.$vs.loading.close();
        },
        async open_direction_of_employment(){
            var data = await this.getDirectionsOfEmployment();

            var arr = data.map((element) => {
                let obj = {
                    name: element.name,
                    uid: element.uid,
                };
                return obj;
            });

            this.directions_of_employment = arr;

        },
        async open_get_vacancies(){
            var data = await this.getVacancies();
            var data2 = []
            data.results.forEach((item)=>{
                var name = item.job.name +' '+ item.company.name
                data2.push({'name':name,'uid':item.uid})

            })
            this.vacancies = data2;
        },
        async open_future_plans(){
            let data = await this.getFuturePlans();
            let arr = data.map((element) => {
                let obj = {
                    name: element.name,
                    uid: element.uid,
                };
                return obj;
            });

            this.future_plans = arr;
        }

    },
    async created() {
        await this.getTypesAddress();
        await this.init();
    },
};
</script>

<style lang="scss" scoped>
.files_input_button {
    // max-width: 220px;
    max-height: 2.7rem;
    position: relative;
    overflow: hidden;
    .con-vs-loading {
        position: absolute;
    }
}
.files_input {
    display: none;
}
.vals_list{
    .item{
        &:not(:last-child){
            margin-bottom: 8px;
        }
    }
}
@media only screen and (min-width: 993px) {
    .vals_list{
        .label{
            min-width: 250px;
        }
    }
}
.avatar_cropper {
    position: relative;
    img {
        max-width: 100%;
        height: 100%;
        max-height: 400px;
    }
}
@media screen and (max-height: 580px) {
    .avatar_cropper {
        img {
            max-height: 300px;
        }
    }
}

.avatarImg img {
    object-fit: cover;
}
</style>

<style scoped>
.number-input {
    border-radius: 5px;
    box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 15%);
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 0.7rem !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    position: relative;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
.button-uploaded {
    color: #2dcd7a;
}
.center {
    justify-content: space-between;
    align-items: center;
}
.submit-buttons {
    display: flex;
    justify-content: flex-end;
}
.button {
    align-items: center;
    display: flex;
    padding-top: 20px;
}
.bold {
    font-weight: bold;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.infos-column {
    display: flex;
    flex-direction: column;
}
.name-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.name {
    font-size: large;
    font-weight: bold;
}
.ok-button {
    border-radius: 30px;
}
.welcone-text {
    align-items: center;
    justify-content: space-between;
    font-size: large;
    font-weight: 600;
    border-radius: 20px 20px 20px 0px;
    color: white;
    background-color: #545da7;
}
.subtitle-text {
    font-weight: 500;
    color: #545da7;
}
.back-div {
    display: flex;
    align-items: center;
}
@media only screen and (min-width: 801px) {
    .subtitle-text {
        font-size: large;
    }
}
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}

</style>
